import FloatingImageAlert from './FloatingImageAlert';
import FloatingAlertContainer from './FloatingAlertContainer';

export { FloatingAlertContainer };

export default FloatingImageAlert;
